// extracted by mini-css-extract-plugin
module.exports = {"service-container":"_4f720283bf--service-container--w9guN"};